import http from "../../core/services/http.service";

const ChecksService = {
  getChecks(params= null) {
    return http.get('/api/v1/settlements/checks-list/', {params})
  }
};

export default ChecksService;